import { render } from "./Preloader.vue?vue&type=template&id=56403b4d&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=56403b4d&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56403b4d"]])

export default __exports__